import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}

const Card: React.FC<CardProps> = ({ children, className = '', hoverEffect = true }) => {
  const baseStyles = 'bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6 transition-all';
  const hoverStyles = hoverEffect ? 'hover:shadow-md hover:-translate-y-1' : '';
  
  return (
    <motion.div 
      className={`${baseStyles} ${hoverStyles} ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
};

export default Card;